'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _renderTitle = require('shared/modules/utils/renderTitle');

var _renderTitle2 = _interopRequireDefault(_renderTitle);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "cost_comparison",
    "title": "Cost Comparison",
    "annual": 5999,
    "salary": 41500,
    "attribution": "Data provided by The U.S. Department of Education’s College Scorecard"
  }

  Specifically for the Educator sidebar, displays average salary information. Has the following
  required attributes: annual (the average annual cost), salary (the average salary after attending,
  and attribution (where the data was sourced from).

  If attribution is the same across the site, then we can hard code this field.
 */

var mapStateToProps = function mapStateToProps(state) {
  return (0, _extends3.default)({}, (0, _selectors.getCostComparisonText)(state));
};

function CostComparison(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      annual = _ref.annual,
      salary = _ref.salary,
      attribution = _ref.attribution,
      annualText = _ref.annualText,
      averageSalaryText = _ref.averageSalaryText;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-cost-comparison ' + moduleClass
    },
    (0, _renderTitle2.default)(title),
    _react2.default.createElement(
      'p',
      null,
      annualText,
      '$',
      annual
    ),
    _react2.default.createElement(
      'p',
      null,
      averageSalaryText,
      '$',
      salary
    ),
    _react2.default.createElement(
      'p',
      { className: 'attribution' },
      attribution
    )
  );
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CostComparison);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/CostComparison/CostComparison.jsx
// module id = 1150
// module chunks = 0